import { putJSON } from 'api/fetch';

import { error as flashError } from 'util/flashNotice';
import { hideGlobalLoader, showGlobalLoader } from 'util/globalLoader';
import { hardRefresh } from 'util/hardRefresh';
import { toI18n } from 'util/i18n';

/**
 * Modern TypeScript utility to change the current location context
 * Replaces the legacy jQuery-based changeLocation method from RailsBridge
 *
 * Matches the exact signature: changeLocation(id, route)
 */
export const changeLocation = (id: number | string, route?: string): void => {
  showGlobalLoader();

  putJSON('/locations/select.json', { id })
    .then(() => {
      hardRefresh(route);
    })
    .catch(() => {
      hideGlobalLoader();
      flashError(toI18n('errors.generic'));
    });
};
